import { Button, Input, InputRef, Tag } from "antd";
import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components"
import { PlusOutlined } from '@ant-design/icons';
import _ from "lodash";

export interface Tag {
    Nombre:string
};

const Container = styled.div`
display: flex;
gap: 0.5rem;
align-items:center;
`;

const Tags = styled.div``;

export interface TagInputProps {
    textButton?: string,
    value?: Tag[],
    onChange?: (value: Tag[]) => any
    tagsContainerStyle?:React.CSSProperties
};

export default (props: TagInputProps) => {
    const [addMode, setAddMode] = useState(false);
    const [tags, setTags] = useState<Tag[]>([]);
    const [newTag, setNewTag] = useState<string>();
    const inputRef = useRef<InputRef>(undefined!);

    useEffect(() => {
        if (addMode) inputRef.current!.focus();
    }, [addMode]);

    useEffect(() => {
        setTags(props.value ?? []);
    }, [props.value]);

    const onAddNewTag = (e?: React.KeyboardEvent<HTMLInputElement>) => {
        if (e?.key != 'Enter') return;
        e?.preventDefault();
        if (!newTag) return;
        if (tags.map(t => t.Nombre).includes(newTag)) return;

        const newTags = [...tags, ...[{Nombre:newTag}]];
        setTags(newTags);
        setAddMode(false);
        props.onChange?.(newTags);
    };

    const onShowTagInput = () => {
        setNewTag("");
        setAddMode(true);
    };

    const onRemoveTag = (tag: string) => {
        const newTags = tags.filter(t => t.Nombre != tag);
        setTags(newTags);
        props.onChange?.(newTags);
    };

    return (
        <Container>
            {tags.length > 0 && <Tags  style={props.tagsContainerStyle}>
                {tags.map(tag => <Tag key={tag.Nombre} closable onClose={() => onRemoveTag(tag.Nombre)} >{tag.Nombre}</Tag>)}
            </Tags>}
            {!addMode && <Button onClick={onShowTagInput} icon={<PlusOutlined />} type="ghost">{props.textButton ?? "Nueva etiqueta"}</Button>}
            {addMode && <Input value={newTag} onChange={(e) => setNewTag(e.target.value)} onKeyDown={onAddNewTag} onBlur={() => setAddMode(false)} style={{ width: 'auto' }} ref={inputRef} />}
        </Container>
    )
}